import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  useIsAdminView,
  useUserRole,
} from 'applications/GSP/shared/hooks/user';
import { UserRole } from 'applications/GSP/shared/types';

export const ROLE_INDICATOR_TEST_ID = 'role-indicator';

export const RoleIndicator = () => {
  const role = useUserRole();
  const { t } = useTranslation();
  const isAdminView = useIsAdminView();

  if (isAdminView) {
    return (
      <Chip
        data-testid={ROLE_INDICATOR_TEST_ID}
        color="secondary"
        variant="filled"
        label={t('GSP.layouts.mainLayout.header.roleIndicator.admin')}
      />
    );
  }

  if (role !== UserRole.Parent) {
    return null;
  }

  return (
    <Chip
      data-testid={ROLE_INDICATOR_TEST_ID}
      color="info"
      variant="filled"
      label={t('GSP.layouts.mainLayout.header.roleIndicator.parent')}
    />
  );
};
